import { render, staticRenderFns } from "./RefundTab.vue?vue&type=template&id=64c5864d"
import script from "./RefundTab.vue?vue&type=script&lang=js"
export * from "./RefundTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports